module.exports = __webpack_public_path__ + "img/close.47beb86d.svg";